import api from "../../api/index.js";

const state = {
    
}

const getters = {

}

const actions = {
    MemberIntegralList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberIntegral/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    MemberIntegralTotal({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberIntegral/Total',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    TurnIntegral({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/MemberIntegral/TurnIntegral',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    TrunCashInCoin({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/MemberIntegral/TrunCashInCoin',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    TrunCoinInCash({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/MemberIntegral/TrunCoinInCash',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
